import React,{useEffect, useState} from "react";
import _ from "lodash";
import { BsExclamationDiamondFill } from "react-icons/bs";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import { renderStartDate, renderEndDate } from "../../resume";
import { formatDate } from "utils/utils";
import { CoverPlaceholderMilestone } from "constants/images"; 
import { useTranslation } from "react-i18next";

export default function ItemMilestone({
  secondaryColor,
  tertiaryColor,
  show_image_milestone = true,
  items,
  headerType = 'featured',
  profile,
  fullPreview,
  milestone_position=[]
}) { ;
  const { t } = useTranslation();
  return (
        <>
          {/* featured, current and past milestones */}
          {items.some(element => element.type === headerType) &&
            !_.isEmpty(items) && (
              <div className="w-full flex flex-col space-x-2 mb-4">
                <div
                  className="px-2 py-1.5 rounded-sm mb-4"
                  style={{ backgroundColor: secondaryColor }}>
                  <p className="text-4xs font-bold text-resumeTempFourTextPrimary tracking-resumeOne">
                    {
                        headerType === 'featured' ? 'Featured Milestones' :
                        headerType === 'current' ? 'Current Milestones'  : 'Past Milestones'
                    }
                  </p>
                </div>
                {items.map((m, i) => (
                  m.type === headerType &&
                  <div key={`featured-${i}`} 
                    className={`mb-2 pr-2 w-full flex flex-row space-x-2.6 items-center`}>
                    { show_image_milestone && 
                    <div className={`bg-default rounded relative h-auto flex items-center justify-center`}>
                      <div className={`relative flex items-center justify-center h-full w-[130px]`}>
                        {m.thumbnail ? (
                          <img
                            alt="milestones"
                            src={m.thumbnail.url}
                            className={`h-[130px] object-contain object-center`}
                          />
                        ) :
                          <div className="flex justify-center items-center h-[130px]">
                            <img
                              alt="milestones"
                              src={CoverPlaceholderMilestone}
                              className="w-[50%] object-contain object-center"
                            />
                          </div>
                        }
                      </div>
                        </div> }
                    <div style={{ width: "calc(100% - 111px)" }}>
                      <div className="flex justify-between items-center space-x-1.5">
                        <div className="flex flex-row items-center space-x-1">
                          {/** title */}
                          <span className="text-4xs font-semibold text-resumeTempFourTextPrimary mt-0.5">
                            {m.title}
                          </span>
                          {/** category */}
                          <span
                            className="font-bold uppercase rounded-sm border text-5xs"
                            style={{
                              color: tertiaryColor,
                              padding: "1.5px 4px 2px 4px",
                            }}>
                            {m?.category?.name}
                          </span>
                        </div>
                        {/** dates */}
                        <div className="flex flex-row flex-wrap text-3xs text-darkGray gap-1">
                          <HiOutlineCalendarDays className="w-2 h-2" />
                          {formatDate(m, profile?.dateFormat,t)}
                        </div>
                      </div>
                      <div className="mb-1 leading-[6.5px] line-clamp-2 ">
                        {/** positions */}
                        <span className={`text-4xs text-darkerGray font-medium${fullPreview ? "text-4xs leading-[11px]" : " leading-[7px] text-3xs"}`}>
                        {m?.positions && m?.positions
                          .filter(item =>
                              !milestone_position.some(hide =>
                                hide?.[m?.id]?.includes(item.position_id)
                              )
                            ).map((p) => {
                            const _pos = [p.position.name?.trim()];
                            if (p.description)
                              _pos.push((p.description).trim());
                            return _pos.join(" - ");
                          })
                          .join(", ")
                          .trim()}
                         {m.platform && <span>{` (${m.platform})`}</span>}
                         {m.date_note && (
                              <>
                                <span> | </span>
                                <span>{`(${m.date_note})`}</span>
                              </>
                            )}
                        </span>
                      </div>
                      {/** description */}
                      {
                       ( m.description && m.description !== 'null') &&
                       <div
                        className={`text-darkerGray tracking-resume line-clamp-7 ${fullPreview ? "text-4xs leading-[11px]" : " leading-[7px] text-3xs"}`}
                        dangerouslySetInnerHTML={{ __html: m.description }}></div>
                      }
                      
                    </div>
                  </div>
                ))}
              </div>
            )}   
        </>  
  );
}


export function ItemMilestoneClone({
  secondaryColor,
  tertiaryColor,
  show_image_milestone = true,
  items,
  headerType = 'featured',
  profile,
  fullPreview,
  milestone_position=[]
}) { ;
  const { t } = useTranslation();
  return (
        <>
              <div className="w-full flex flex-col space-x-2 mb-4 py-1.5">
                  <div key={`featured-${items.id}`} 
                    className={`mb-2 pr-2 w-full flex flex-row space-x-2.6 items-center`}>
                    { show_image_milestone && 
                    <div className={`bg-default rounded relative h-auto flex items-center justify-center ${fullPreview ? "2md:min-h-[130px] 2md:w-[130px]" : "2md:min-h-[70px] 2md:w-[70px]"}`}>
                      <div className={`relative flex items-center justify-center h-full w-full ${fullPreview ?  "2md:w-[130px]" : "2md:w-[70px]"}`}>
                        {items.thumbnail ? (
                          <img
                            alt="milestones"
                            src={items.thumbnail.url}
                            className={`h-auto object-contain object-center ${fullPreview ?  "2md:max-h-[130px]" : "2md:max-h-[70px]"}`}
                          />
                        ) :
                          <div className="flex justify-center items-center h-full">
                            <img
                              alt="milestones"
                              src={CoverPlaceholderMilestone}
                              className="w-[50%] object-contain object-center"
                            />
                          </div>
                        }
                      </div>
                        </div> }
                    <div > {/**style={{ width: "calc(100% - 111px)" }} */}
                      <div className="flex justify-between items-center space-x-1.5">
                        <div className="flex flex-row items-center space-x-1">
                          {/** title */}
                          <span className="text-4xs font-semibold text-resumeTempFourTextPrimary mt-0.5">
                            {items.title}
                          </span>
                          {/** category */}
                          <span
                            className="font-bold uppercase rounded-sm border text-5xs"
                            style={{
                              color: tertiaryColor,
                              padding: "1.5px 4px 2px 4px",
                            }}>
                            {items?.category?.name}
                          </span>
                        </div>
                        {/** dates */}
                        <div className="flex flex-row flex-wrap text-3xs text-darkGray gap-1">
                          <HiOutlineCalendarDays className="w-2 h-2" />
                          {formatDate(items, profile?.dateFormat,t)}
                        </div>
                      </div>
                      <div className="mb-1">
                        {/** positions */}
                        {items?.positions && items?.positions
                          .filter(item =>
                              !milestone_position.some(hide =>
                                hide?.[item?.id]?.includes(item.position_id)
                              )
                            ).map((p, i) => (
                          <div
                            key={`featured-position-${i}`}
                            className="text-1xs text-darkerGray font-semibold">
                            <span>
                              <span>{p.position.name} {p.position_id}</span>
                              {p.position?.description && (
                                <>
                                  <span> - </span>
                                  <span>{p.position.description}</span>
                                </>
                              )}
                              {items.platform && <span>{` (${items.platform})`}</span>}
                            </span>
                            {items.date_note && (
                              <>
                                <span> | </span>
                                <span>{`(${items.date_note})`}</span>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                      {/** description */}
                      {
                       ( items.description && items.description !== 'null') &&
                       <div
                        className={`text-darkerGray tracking-resume line-clamp-7 ${fullPreview ? "text-1xs" : "text-1xs"}`}
                        dangerouslySetInnerHTML={{ __html: items.description }}></div>
                      }
                      
                    </div>
                  </div> 
              </div> 
        </>  
  );
}
